import React, { type FC } from 'react'

import { Capability, type CybusDetailedMapping, CybusLogSource, Translation } from '../../../../domain'

import Logs, { LogsAvailability } from '../../Logs'
import { Tab, Tabs } from '../../Tabs'
import { Entries } from './Entries'

export const Content: FC<Readonly<{ resource: CybusDetailedMapping }>> = ({ resource }) => {
    const { id, entries, status } = resource

    return (
        <LogsAvailability type={CybusLogSource.MAPPING} id={id}>
            {(available) => (
                <Tabs>
                    <Tab title={Translation.MAPPING_LOGS} disabled={!available} requiredCapabilities={[Capability.LOGS_READ]}>
                        <Logs id={id} type={CybusLogSource.MAPPING} reloadOn={resource} />
                    </Tab>
                    <Tab title={Translation.ENTRY} requiredCapabilities={[Capability.TOPICS_SUBSCRIPTION]}>
                        <Entries entries={entries} status={status} />
                    </Tab>
                </Tabs>
            )}
        </LogsAvailability>
    )
}
